import youtube from '../Assets/Imgs/youtube.png';
import spotify from '../Assets/Imgs/spotify.png';
import appleMusic from '../Assets/Imgs/apple music.jpg';

import lolCurse from '../Assets/Imgs/Lol Curse.jpg';
import monsterEGirl from '../Assets/Imgs/MonsterEGirl.jpg';
import starKillLovers from '../Assets/Imgs/StarKillLoversSmall.jpg';
import dumbestTimelineCover from '../Assets/Imgs/The-Dumbest-Timeline-Album-Cover.jpg';

import logoSmall from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';

import CheerTag from './CheerTag';

const MusicPlayer3D = () => {

  const songChoose = (e, card) => {
    //document.querySelector('.carouselOrbitalBorder').classList.toggle('carouselOrbitalExpansion');
    document.querySelector('.carouselOrbitalBorder2').classList.toggle('carouselOrbitalExpansion2');

    if(card === 'c1'){
      document.querySelector('.carousel').classList.toggle('c1Stop');
      document.querySelector('.cb1InfoLeft').classList.toggle('left');
      document.querySelector('.cb1InfoLeft').classList.toggle('songChooseTop37');
      e.target.classList.toggle('carouselCardChooseC1');
      return false
    }

    if(card === 'c2'){
      document.querySelector('.carousel').classList.toggle('c2Stop');
      document.querySelector('.cb2InfoLeft').classList.toggle('left137');
      document.querySelector('.cb2InfoLeft').classList.toggle('songChooseTop28');
      e.target.classList.toggle('carouselCardChooseC2');
      return false
    }

    if(card === 'c3'){
      document.querySelector('.carousel').classList.toggle('c3Stop');
      document.querySelector('.cb3InfoLeft').classList.toggle('left127');
      document.querySelector('.cb3InfoLeft').classList.toggle('songChooseTop16');
      e.target.classList.toggle('carouselCardChooseC3');
      return false
    }
  }

  return (
    <header className="App-header-carousel">
      <div className="carouselTitle">
        <img src={logoSmall} className="logoInCarouselTitle" />
        <p className="">Press It</p>
      </div>
      <div className="carousel">
        {/*<div className="carouselOrbitalBorder" /> */}
        <div className="carouselOrbitalBorder2 borderBlink" />
        <div className="card c1" onClick={(e)=>{songChoose(e, 'c1')}} >
          <div className="img"><img src={monsterEGirl} className="App-logo" alt="monster e girl" /></div>
          <p>Monster E Girl</p>
          <span>Album: Lol</span>
        </div>
        <div className="cardb cb1">
          <div className='cb1InfoLeft'>
            <a className="cardSpotifyLink" href="https://open.spotify.com/track/07ZblHy1uBAMJ7B2A0vVzN">
              <img src={spotify} alt="spotify" className="icon invert" />
                Play
            </a>
            <a className='cardSpotifyLink' href="https://music.apple.com/us/album/monster-e-girl/1706811361?i=1706811366">
              <img src={appleMusic} alt="spotify" className="icon" />
              Play
            </a>
            <a className='cardSpotifyLink' href="https://youtu.be/-K5_ImrIq2w">
              <img src={youtube} alt="spotify" className="icon" />
              Play
            </a>
          </div>
        </div>
        <div className="card c2" onClick={(e)=>{songChoose(e, 'c2')}} >
          <div className="img"><img src={lolCurse} className="App-logo" alt="lolcurse" /></div>
          <p>Lol Curse</p>
          <span>Album: Lol</span>
        </div>
        <div className="cardb cb2">
          <div className='cb2InfoLeft'>
            <a className="cardSpotifyLink" href="https://open.spotify.com/track/0C0uOFGdkd9TBsLBxTSed5">
              <img src={spotify} alt="spotify" className="icon invert" />
                Play
            </a>
            <a className='cardSpotifyLink' href="https://music.apple.com/us/album/lol-curse-single/1688343595">
              <img src={appleMusic} alt="spotify" className="icon" />
              Play
            </a>
            <a className='cardSpotifyLink' href="https://youtu.be/vcT_HHMGgzc">
              <img src={youtube} alt="spotify" className="icon" />
              Play
            </a>
          </div>
        </div>
        <div className="card c3" onClick={(e)=>{songChoose(e, 'c3')}}>
          <div className="img"><img src={starKillLovers} className="App-logo" alt="lolcurse" /></div>
          <p>Star Kill Lovers</p>
          <span>Album: </span>
        </div>
        <div className="cardb cb3">
          <div className='cb3InfoLeft'>
            <a className="cardSpotifyLink" href="https://open.spotify.com/track/4pRVbRjUTaeKlKOJK6HBXW">
              <img src={spotify} alt="spotify" className="icon invert" />
                Play
            </a>
            <a className='cardSpotifyLink' href="https://music.apple.com/us/album/star-kill-lovers/1871855183?i=1871855676">
              <img src={appleMusic} alt="spotify" className="icon" />
              Play
            </a>
            <a className='cardSpotifyLink' href="https://youtu.be/HRUJIDi6gYw">
              <img src={youtube} alt="spotify" className="icon" />
              Play
            </a>
          </div>
        </div>
      </div>

      <CheerTag />

    </header>
  );
}

export default MusicPlayer3D;